<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.shops') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server ref="shoplist" v-model:items-per-page="itemsPerPage"
                :items-per-page-options="pageOptions" density="compact" @update:page="updatePage" :headers="headers"
                :items="serverItems" :items-length="totalItems" :loading="loading" :search="searchTerm"
                item-value="name" @update:options="loadItems" height="60vh" fixed-header :update:sortBy="updateSortBy"
                :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table">
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false"
                                :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="pb-2 py-0 bg-white" height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <!-- <CustomFilterMenu :title="'status'" :items="['disabled','published','pending','created']" v-model="filter" :multiple="true"></CustomFilterMenu> -->
                            <!-- {{ filter }} -->
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.publicityState`]="{ value }">
                    <!-- {{ value }} -->
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="x-small" color="success"
                                v-if="value == 'published'">mdi-check-circle-outline</v-icon>
                            <v-icon v-bind="props" size="x-small" color="error"
                                v-else-if="value == 'pending'">mdi-help-circle</v-icon>
                            <v-icon v-bind="props" size="x-small" color="warning"
                                v-else-if="value == 'denied'">mdi-minus-circle</v-icon>
                            <v-icon v-bind="props" size="x-small" color="error"
                                v-else-if="value == 'deactivated'">mdi-cancel</v-icon>
                            <v-icon v-bind="props" size="x-small" color="primary"
                                v-else-if="value == 'created'">mdi-circle</v-icon>
                        </template>
                        <span>{{ value }}</span>
                    </v-tooltip>

                </template>
                <template v-slot:[`item.user.profile.language`]="props">
                    <v-menu location="bottom" class="language-menu">
                        <template v-slot:activator="{ props: menuProps }">
                            <v-btn v-bind="menuProps" :ripple="false" elevation="0" size="x-small">
                                <img :src="`/images/flag-${props.item?.user.profile.language?.toLowerCase() || 'de'}.png`"
                                    height="24" width="24">
                                <v-icon icon="mdi-menu-down"></v-icon>
                            </v-btn>
                        </template>

                        <v-list density="compact">
                            <v-list-item
                                :class="{ 'active': props.item?.user.profile.language.toLowerCase() == lang.code }"
                                v-for="(lang, index) in languages" :key="index"
                                @click="changeShopLanguage(props.item, lang)" density="compact">
                                <v-list-item-title><img :src="lang.img" height="24" width="24"> {{ lang.title
                                    }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <!-- <v-chip :text="value" size="x-small"></v-chip> -->
                </template>
                <template v-slot:[`item.email`]="{ value }">
                    {{ value }}
                    <!-- <v-chip :text="value" size="x-small"></v-chip> -->
                </template>
                <template v-slot:[`item.areas`]="props">
                    <v-btn size="x-small" class="px-0" variant="outlined" outlined
                        @click="() => editShopAreas(props.item)">
                        {{ props.item.areasData.length }}
                    </v-btn>
                </template>
                <template v-slot:[`item.targets`]="props">
                    <v-btn size="x-small" class="px-0" variant="outlined" @click="() => editShopTarget(props.item)">
                        edit</v-btn>
                </template>
                <template v-slot:[`item.status`]="props">
                    <v-btn variant="outlined" size="x-small" @click="() => editPlanData(props.item)"> {{
                        props.item.status
                            != null ? props.item.status : 'none' }} </v-btn>
                </template>
                <template v-slot:[`item.edit`]="props">
                    <!-- <v-btn class="mx-2" flat fab dark size="x-small" color="transparent"
                        @click="onButtonClick(props.item)" icon="mdi-pencil">
                    </v-btn> -->
                    <v-icon size="small" @click="() => impersonateUser(props.item)">mdi-pencil</v-icon>
                </template>
                <template v-slot:[`item.created`]="{ value }">
                    {{ $formatDateWithoutDay(value) }}
                </template>
                <template v-slot:[`item.user.lastLogin`]="{ value }">
                    {{ $formatDateWithoutDay(value) }}
                </template>
                <!-- <template v-slot:[`item.info`]="props">
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information-variant</v-icon>
                        </template>
                        <span>created: {{ $formatDate(props.item.created) }}</span><br>
                        <span>last Login: {{ $formatDate(props.item.user.lastLogin) }}</span>
                    </v-tooltip>
                </template> -->
                <template v-slot:[`item.controls`]="props">
                    <v-menu class="actions-menu" location="left">
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" size="x-small" class="mx-2" flat dark x-small color="transparent"
                                icon="mdi-chevron-down">
                            </v-btn>
                        </template>
                        <v-list :density="'compact'" lines="false">
                            <v-list-item density="compact" v-if="props.item.publicityState === 'pending'"
                                @click="() => updatePublicityState(props.item, 'denied')">
                                <v-list-item-title><v-icon size="x-small" color="warning">mdi-minus-circle</v-icon>
                                    {{ $t('entity.action.deny') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact"
                                v-if="props.item.publicityState === 'deactivated' || props.item.publicityState === 'pending'"
                                @click="() => updatePublicityState(props.item, 'published')">
                                <v-list-item-title><v-icon size="x-small"
                                        color="success">mdi-check-circle-outline</v-icon>
                                    {{ $t('entity.action.activate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact" v-if="props.item.publicityState !== 'deactivated'"
                                @click="() => updatePublicityState(props.item, 'deactivated')">
                                <v-list-item-title><v-icon size="x-small" color="error">mdi-cancel</v-icon>
                                    {{ $t('entity.action.deactivate') }}</v-list-item-title>
                            </v-list-item>
                            <!--  -->
                            <v-list-item density="compact" class="text-right">
                                <v-list-item-title><v-icon size="x-small" color="black">mdi-email-outline</v-icon> send
                                    credentials</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="black">mdi-cached</v-icon> send
                                    reminder</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="error">mdi-trash-can-outline</v-icon>
                                    delete
                                    shop</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact" @click="() => openChangelog(props.item.id)">
                                <v-list-item-title><v-icon size="x-small" color="black">mdi-file-outline</v-icon>
                                    changelog</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                </template>

            </v-data-table-server>
        </v-row>
        <ShopAreasDialog v-model="showAreasDialog" v-model:data="editShop" :items="mappedData" :save="updateShopAreas"
            type="shop">
        </ShopAreasDialog>
        <ShopChangelogDialog v-model="showChangelogDialog" :items="changeLogs"></ShopChangelogDialog>
        <ShopTargetDialog v-model="showTargetDialog" v-model:data="editShop" :items="targetData"
            :save="updateShopTargets">
        </ShopTargetDialog>
        <ShopPlanDialog v-model="showPlanDialog" v-model:data="editShop" :items="planData"></ShopPlanDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CustomFilterMenu from '../custom/CustomFilterMenu.vue';
import ShopAreasDialog from './modals/ShopAreasDialog.vue';
import ShopTargetDialog from './modals/ShopTargetDialog.vue';
import ShopPlanDialog from './modals/ShopPlanDialog.vue';
import ShopChangelogDialog from './modals/ShopChangelogDialog.vue';
import { impersonateUser } from '@/utils/auth';
export default {
    components: {
        CustomFilterMenu,
        ShopAreasDialog,
        ShopTargetDialog,
        ShopPlanDialog,
        ShopChangelogDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const editShop = ref({});
        const showAreasDialog = ref(false);
        const showPlanDialog = ref(false);

        onMounted(() => {
            fetchData();
            fetchTargetData();
            fetchPlanData();
        });

        const shoplist = ref();

        const updatePage = (newPage) => {
            proxy.page = newPage;
        }
        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }
        const targetData = ref({})
        const planData = ref([])
        const status = ref([])
        const features = ref([])

        const fetchPlanData = async () => {
            try {
                const [statusRes, featuresRes] = await Promise.all([
                    proxy.$axios.get(`/backoffice/shop/status`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    }),
                    proxy.$axios.get(`/backoffice/features`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    }),
                ]);

                if (statusRes.data.status === "OK") {
                    status.value = statusRes.data.data;
                }
                if (featuresRes.data.status === "OK") {
                    features.value = featuresRes.data.data;
                }

                planData.value = { status: status.value, features: features.value, }

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                loading.value = false;
            }
        }

        const editPlanData = (item) => {
            editShop.value = { ...item }
            showPlanDialog.value = true;
        }


        const attributes = ref([])
        const labels = ref([])
        const labelcategories = ref([])
        const showTargetDialog = ref(false);
        const showChangelogDialog = ref(false);
        const changeLogs = ref([])


        const fetchTargetData = async () => {

            try {
                const [attributesRes, labelsRes, labelcategoriesRes] = await Promise.all([
                    proxy.$axios.get(`/backoffice/attributes`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    }),
                    proxy.$axios.get(`/backoffice/labels`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    }),
                    proxy.$axios.get(`/backoffice/labelcategories`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    })
                ]);

                if (attributesRes.data.status === "OK") {
                    attributes.value = attributesRes.data.data;
                }
                if (labelsRes.data.status === "OK") {
                    labels.value = labelsRes.data.data;
                }
                if (labelcategoriesRes.data.status === "OK") {
                    labelcategories.value = labelcategoriesRes.data.data;
                }

                targetData.value = { attributes: attributes.value, labels: labels.value, labelcategories: labelcategories.value }

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                loading.value = false;
            }

        }

        const originalShopCopy = ref(null)
        const editShopTarget = (item) => {
            originalShopCopy.value = item;
            editShop.value = { ...item };
            showTargetDialog.value = true;
        }

        const areArraysEqualById = (array1, array2) => {
            if (array1.length !== array2.length) return false;

            const ids1 = new Set(array1.map(item => item.id));
            const ids2 = new Set(array2.map(item => item.id));

            return ids1.size === ids2.size && [...ids1].every(id => ids2.has(id));
        }

        const updateShopTargets = async () => {

            const promises = [];


            if (!areArraysEqualById(originalShopCopy.value.labels, editShop.value.labels)) {
                promises.push(updateShopLabels(editShop.value.id, editShop.value.labels))
            }
            if (!areArraysEqualById(originalShopCopy.value.attributes, editShop.value.attributes)) {
                promises.push(updateShopAttributes(editShop.value.id, editShop.value.attributes))
            }
            if (originalShopCopy.value.pricing !== editShop.value.pricing) {
                promises.push(updateShopPricing(editShop.value.id, editShop.value.pricing))
            }

            await Promise.all(promises);

            // Close the dialog after everything is done
            showTargetDialog.value = false;
            proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
            //{labelIds: ["63d84ce2-af22-4f82-8b16-157907765a96", "66ec3a65-3c47-43a0-9856-553918896664"]} PUT /shop/7e8c6bad-f040-4fcc-a854-dc4fa5d0f27e/labels
            //  {uuids: ["b60ebe2f-2451-4f15-ae37-69c860c59f11", "fccee441-6591-42d1-8c4e-bd3112dfa7f4"]} POST /backoffice/attributes/shop/7e8c6bad-f040-4fcc-a854-dc4fa5d0f27e
            // {pricing: "HIGH"} PUT /backoffice/shop/7e8c6bad-f040-4fcc-a854-dc4fa5d0f27e/pricing
        }

        const updateShopLabels = async (id, labels) => {
            const obj = { labelIds: labels.map(item => item.id) }
            try {
                const response = await proxy.$axios.put(`/shop/${id}/labels`, obj,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                // if (response.data.status == "OK") {
                //     proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage });
                // }
            } catch (error) {
                console.error("Error: ", error);
            } finally {
                showTargetDialog.value = false;
            }
        }
        const updateShopPricing = async (id, pricing) => {
            const obj = { pricing: pricing }
            try {
                const response = await proxy.$axios.put(`/backoffice/shop/${id}/pricing`, obj,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                // if (response.data.status == "OK") {
                //     proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage });
                // }
            } catch (error) {
                console.error("Error: ", error);
            } finally {
                showTargetDialog.value = false;
            }
        }

        const updateShopAttributes = async (id, attributes) => {
            const obj = { uuids: attributes.map(item => item.id) }
            try {
                const response = await proxy.$axios.post(`/backoffice/attributes/shop/${id}`, obj,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                // if (response.data.status == "OK") {
                //     proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage });
                // }
            } catch (error) {
                console.error("Error: ", error);
            } finally {
                showTargetDialog.value = false;
            }
        }

        const editShopAreas = (shop) => {
            editShop.value = { ...shop };
            showAreasDialog.value = true;
        }

        const loading = ref(false);
        const countries = ref([]);
        const districts = ref([]);
        const mappedData = ref([]);

        const fetchData = async () => {
            loading.value = true; // Show loading indicator
            try {
                const [countriesRes, districtsRes] = await Promise.all([
                    proxy.$axios.get(`/backoffice/country/all`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    }),
                    proxy.$axios.get(`/backoffice/cities`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    })
                ]);

                if (countriesRes.data.status === "OK") {
                    countries.value = countriesRes.data.data;
                }
                if (districtsRes.data.status === "OK") {
                    districts.value = districtsRes.data.data;
                }

                // ✅ Map Data Only Once
                const objectMap = new Map((districts.value || []).map(obj => [obj.id, obj]));
                mappedData.value = (countries.value || []).map(group => ({
                    ...group,
                    // preloadedChildren: group.areaIds.map(id => objectMap.get(id)).filter(Boolean),
                    children: group.areaIds.map(id => objectMap.get(id)).filter(Boolean),
                    // children:[]
                }));

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                loading.value = false;
            }
        };

        const filter = ref([])
        const search = ref('')
        const searchTerm = computed(() => {
            return search.value.length >= 2 ? search.value : '';
        });

        const updatePublicityState = (shop, newState) => {
            console.log("updatePublicityState", shop, newState)
            if (newState === 'published' && typeof shop.referenceShopId === 'undefined') {
                if (validateShopBeforeActivation(shop)) {
                    // openLinkStoreDialog(shop, true, function () {
                    savePublicityState(shop, 'published');
                    // });
                }
            } else {
                savePublicityState(shop, newState);
            }
        }

        const savePublicityState = async (shop, newState) => {
            console.log("savePublicityState Shop", shop)
            console.log("savePublicityState newState", newState)
            // TODO {publicityState: "deactivated"} // PUT /api/backoffice/shop/01a73871-a655-4fa7-bcee-368b5b483176
            const obj = { publicityState: newState }
            try {
                const response = await proxy.$axios.put(`/backoffice/shop/${shop.id}`, obj,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                if (response.data.status == "OK") {
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error: ", error);
            } finally {
                showTargetDialog.value = false;
            }
        }

        const validateShopBeforeActivation = (shop) => {
            var hasAreas = shop.areaIds && shop.areaIds.length > 0;
            var hasAttributes = shop.attributes && shop.attributes.length > 0;
            var hasPriceRange = !!shop.pricing;
            var isValidShop = hasAreas && hasAttributes && hasPriceRange;
            console.log("hasAreas", hasAreas)
            console.log("hasAttributes", hasAttributes)
            console.log("hasPriceRange", hasPriceRange)
            // TODO Notification
            // if (!hasAreas) {
            //     Notification.error($translate.instant('global.menu.backoffice.validate.areas'));
            // } else if (!hasAttributes) {
            //     Notification.error($translate.instant('global.menu.backoffice.validate.attributes'));
            // } else if (!hasPriceRange) {
            //     Notification.error($translate.instant('global.menu.backoffice.validate.pricing'));
            // }
            console.log("isValidShop", isValidShop);
            return isValidShop;
        }

        const updateShopAreas = async () => {
            // {areaIds: ["d3fc6c4b-6bd1-4212-8250-1419b98d0377"]} PUT /api/backoffice/shop/01a73871-a655-4fa7-bcee-368b5b483176/areas
            const obj = { areaIds: editShop.value.areaIds.map(item => typeof item === 'object' && item !== null ? item.id : item) }
            try {
                const response = await proxy.$axios.put(`/backoffice/shop/${editShop.value.id}/areas`, obj,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                if (response.data.status == "OK") {
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error: ", error);
            } finally {
                showAreasDialog.value = false;
            }
        }

        const onButtonClick = (val) => {
            console.log('Button Clicked', val)
        }

        const openChangelog = async (id) => {
            showChangelogDialog.value = true;
            try {
                const response = await proxy.$axios.get(`/backoffice/changelog/${id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                })

                if (response.data.status === "OK") {
                    changeLogs.value = response.data.data;
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
            // GET /api/backoffice/changelog/737965b2-c394-40df-90cd-81db709004ca
        }

        const changeShopLanguage = async (item, lang) => {
            const obj = { language: lang.code.toUpperCase() }
            try {
                const response = await proxy.$axios.post(`/backoffice/shop/${item.id}/lang`, obj,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                if (response.data.status == "OK") {
                    // console.log('proxy.page,proxy.itemsPerPage', proxy.page, proxy.itemsPerPage)
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error: ", error);
            }

            // {language: "DE"} POST /backoffice/shop/179d39d8-41b2-4661-8112-98c6bef53f25/lang
        }

        const languages = [
            { title: t('german'), img: '/images/flag-de.png', code: 'de' },
            { title: t('english'), img: '/images/flag-en.png', code: 'en' }
        ];

        return {
            selectedLanguage,
            onButtonClick,
            languages,
            filter,
            changeShopLanguage,
            updatePublicityState,
            search,
            searchTerm,
            editShop,
            showAreasDialog,
            editShopAreas,
            districts,
            mappedData,
            updateShopAreas,
            shoplist,
            updatePage,
            updateShopTargets,
            targetData,
            planData,
            fetchTargetData,
            editShopTarget,
            showTargetDialog,
            showChangelogDialog,
            showPlanDialog,
            editPlanData,
            openChangelog,
            changeLogs,
            impersonateUser,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        itemsPerPage: 50,
        page: 1,
        sortBy:[],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            // { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: ' ', key: 'publicityState', align: 'start', sortable: false, maxWidth: '20px' },
            { title: 'Edit', value: "edit", align: 'start', sortable: false, maxWidth: '20px' },
            {
                title: 'Name',
                align: 'start',
                maxWidth: "200px",
                sortable: true,
                key: 'name',
            },
            { title: 'Lang', key: 'user.profile.language', align: 'start', maxWidth: '50px' },
            { title: 'User-Mail', key: 'user.email', align: 'start', maxWidth: "250px" },
            { title: 'Username', key: 'user.username', align: 'start', maxWidth: "250px" },
            { title: 'areas', value: "areas", align: 'start', maxWidth: '50px' },
            { title: 'target', value: "targets", align: 'start' },
            { title: 'Plan', key: 'status', align: 'start' },
            { title: 'created', value: "created", align: 'end', sortable: true },
            { title: 'lastLogin', value: "user.lastLogin", align: 'end', sortable: true },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        refresh() {
            this.$refs.shoplist.refresh()
            this.pageOptions = [...this.pageOptions]
            // shoplist.value.refresh();
        },
        loadItems({ page, itemsPerPage, sortBy }) {
            console.log("sortBy", sortBy);
            this.loading = true
            const hardToken = localStorage.getItem("hardToken");
            const softToken = localStorage.getItem("softToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.searchTerm.length >= 1 ? "/backoffice/v2/shop/query" : "/backoffice/shops", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
                params: {
                    sortColumn: sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    ...(this.searchTerm.length >= 1 ? { name: this.searchTerm, resultsPerPage: itemsPerPage, page: page - 1 } : { page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1600px;
    margin-top: 40px;
}

.actions-menu .v-list .v-list-item-title {
    font-size: 12px !important;
}

.language-menu .v-list .v-list-item-title {
    font-size: 12px !important;
}
</style>

<style>
.shop-list-table table thead.v-data-table__thead {
    font-size: 11px !important;
}

.shop-list-table table tbody.v-data-table__tbody {
    font-size: 13px !important;
}

.shop-list-table table tbody.v-data-table__tbody .v-list {
    font-size: 13px !important;
}

/*.shop-list-table table tbody.v-data-table__tbody .v-data-table__tr td:nth-child(5),
.shop-list-table table tbody.v-data-table__tbody .v-data-table__tr td:nth-child(4) {
    word-break: break-word;
}*/
</style>

<style></style>